<template>
  <div>
    <div>
      <Row class="expand-row">
        <Table
          :no-data-text="$t('common.noData')"
          :columns="columns"
          :data="securityData"
          style="width: 100%"
        ></Table>
      </Row>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    row: Object,
  },
  data() {
    return {
      columns: [
        {
          title: this.$t("RAM.AWS.routingTable.ipAddress"),
          key: "ipAddress",
        },
        {
          title: this.$t("RAM.AWS.routingTable.instanceId"),
          key: "instanceId",
        },
        {
          title: this.$t("RAM.AWS.routingTable.gatewayId"),
          key: "gatewayId",
        },
        {
          title: this.$t("RAM.AWS.routingTable.routeState"),
          key: "routeState",
        },
      ],
      securityData: this.row.resourceAwsRouteDTOS,
    };
  },
};
</script>
<style scoped>
.expand-row {
  padding-left: 17px;
  margin-bottom: 10px;
}
.expand-key {
  width: 145px;
  display: block;
  float: left;
}
</style>



// WEBPACK FOOTER //
// src/components/configuration/resource_configuration_management/aws/route/TableExpand.vue